import styled from 'styled-components';
import { motion } from 'framer-motion';
import constants from 'src/constants';
import { screenshotModeTopPadding } from 'src/components/ScreenshotMode/styled';

const { ASPECT_RATIO } = constants.screenshot;

const screenshotModeBottomPadding = 100;
const calcMaxWidthByMaxHeight = `calc((100vh - ${screenshotModeTopPadding}px - ${screenshotModeBottomPadding}px) * 3 / 2)`;

export const AspectContainer = styled('div')`
  width: 100%;
  max-width: ${calcMaxWidthByMaxHeight};
  margin-right: 30px;
`;

export const HeightContainer = styled('div')`
  position: relative;
  /*
    we use padding to set the height because when setting padding to 100% its 100% of width (not height)
    this way, we can set the max width above and just set padding easily with the aspectRatio
    this is also why we nest the height container within the width container
  */
  padding-bottom: ${100 / ASPECT_RATIO}%;
`;

export const CameraFlash = styled(motion.div).attrs({
  animate: { opacity: [1, 0] },
  transition: { duration: 0.5 },
})`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: 1;
  background-color: white;
`;
